// Iter 66b: i18n (IT default, EN). Fase 1: vetrina + login + registrazione.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const it = {
  common: {
    accedi: "Accedi",
    provaGratis: "Prova gratis",
    email: "Email",
    password: "Password",
  },
  auth: {
    tagline: "Le ore della tua squadra, sotto controllo",
    regTitle: "Crea la tua azienda",
    regSub: "Prova gratis per 14 giorni, senza carta di credito. I dati della tua azienda sono privati e isolati.",
    regAzienda: "Nome azienda *",
    regAziendaPh: "es. Rossi Impianti Srl",
    regNome: "Il tuo nome e cognome *",
    regNomePh: "es. Mario Rossi",
    regPassword: "Password * (min. 6 caratteri)",
    regLoading: "Creazione in corso…",
    emailRequired: "Inserisci la tua email",
    emailInvalid: "Email non valida: controlla l'indirizzo (es. nome@azienda.it)",
    pwdRequired: "Inserisci la password",
    pwdMin: "La password deve avere almeno 6 caratteri",
    fieldRequired: "Compila questo campo",
    regSubmit: "Inizia la prova gratuita",
    regBack: "Hai già un account? Accedi",
    loginSub: "Inserisci le tue credenziali per continuare.",
    loginLoading: "Accesso in corso…",
    loginDemo: "🧪 Prova la demo — senza registrazione",
    loginRegister: "Nuova azienda? Prova gratis 14 giorni →",
    heroA: "Le ore della tua squadra,",
    heroB: "sempre sotto controllo.",
  },
  landing: {
    nav: { funzioni: "Funzionalità", ovunque: "Cantiere & Ufficio", prezzi: "Prezzi", faq: "Domande" },
    hero: {
      kicker: "Per imprese, cantieri e officine",
      h1a: "Le ore della tua squadra,",
      h1b: "sempre sotto controllo.",
      sub: "Basta fogli volanti e ore ricostruite a fine mese: i capi cantiere compilano i rapportini dal telefono in 30 secondi — anche senza internet — e l'ufficio vidima, stampa e archivia dal computer. E ogni giorno una frase motivazionale carica i tuoi responsabili e aumenta la resa della squadra.",
      cta: "Prova gratis 14 giorni",
      demo: "Guarda la demo",
      nocard: "Nessuna carta di credito richiesta · Disdici quando vuoi",
      badges: ["DIPENDENTI ILLIMITATI", "FUNZIONA OFFLINE", "MOTIVAZIONE QUOTIDIANA", "ANDROID · IPHONE · PC", "PDF & EMAIL AUTOMATICHE"],
    },
    ovunque: {
      kicker: "Un'unica app, due modi di usarla",
      title: "Il telefono in cantiere, il PC in ufficio.",
      sub: "Stessi dati, sempre sincronizzati: ognuno lavora dallo strumento più comodo.",
      mobileTitle: "In cantiere, dal telefono",
      mobile: [
        "I capi cantiere segnano le ore appena finito il turno, in 30 secondi",
        "Funziona anche senza segnale: sincronizza da solo dopo",
        "Scaricala dal Google Play Store su Android, o installala dal browser su iPhone",
      ],
      pcTitle: "In ufficio, dal computer",
      pc: [
        "Stesso account del telefono: i rapportini fatti in cantiere compaiono subito sul PC",
        "Dal browser senza installare nulla — oppure clicca \"Installa\" in Chrome o Edge e diventa un programma con icona sul desktop",
        "Vidimazione, stampe PDF, statistiche ed export Excel comodi dalla scrivania, con schermo grande e tastiera",
      ],
    },
    funzioni: {
      kicker: "Tutto quello che serve",
      title: "Dal rapportino alla busta paga, senza carta.",
      items: [
        { title: "Rapportini in 30 secondi", desc: "Compila le ore di tutta la squadra dal telefono, anche per più giorni insieme. Il modulo si popola da solo con dipendenti e commesse." },
        { title: "Funziona senza internet", desc: "In cantiere il segnale va e viene: IL-Report salva tutto sul dispositivo e sincronizza da solo appena torna la rete." },
        { title: "Vidimazione dell'ufficio", desc: "L'amministrazione controlla e vidima i rapportini con un clic. Tutto tracciato: chi, cosa, quando." },
        { title: "PDF ed email automatiche", desc: "Stampe ore mensili per dipendente e invio dei rapportini via email in PDF, pronti per consulente e buste paga." },
        { title: "Commesse e budget ore", desc: "Ogni ora finisce sulla commessa giusta. Budget ore con avvisi quando ti avvicini al limite: basta sforamenti scoperti a fine mese." },
        { title: "Statistiche immediate", desc: "Ore per commessa, per dipendente, per periodo. Sai sempre dove va il lavoro della tua squadra." },
        { title: "Motivazione quotidiana", desc: "Non solo gestione: una frase del giorno pensata per capi cantiere e capi officina carica chi guida la squadra e aumenta la resa delle persone, un giorno alla volta." },
      ],
    },
    prezzi: {
      kicker: "Prezzi semplici",
      title: "Prezzo fisso. Dipendenti illimitati.",
      sub: "Le altre app fanno pagare per ogni dipendente: con 20 operai spenderesti 100€ e più al mese. Con IL-Report il prezzo non cambia mai, che tu abbia 5 o 50 dipendenti.",
      featured: "Il più scelto",
      alMese: "/mese + IVA",
      senzaCarta: "Senza carta di credito",
      baseClaim: "Per chi vuole rapportini e ore in ordine",
      base: ["Dipendenti e rapportini illimitati", "Funziona offline in cantiere", "Vidimazione dell'ufficio", "Stampe ore mensili in PDF", "500 email al mese incluse"],
      proClaim: "Per chi vuole anche controllo e analisi",
      pro: ["Tutto il piano Base, più:", "Statistiche complete per commessa e dipendente", "Budget ore con avvisi di sforamento", "Export per il gestionale e il consulente", "Email illimitate"],
      note1: "Pagamento sicuro con carta o PayPal",
      note2: "Mensile, senza vincoli",
      note3: "Attivazione immediata",
    },
    faq: {
      kicker: "Domande frequenti",
      title: "Tutto chiaro prima di iniziare.",
      items: [
        { q: "Devo inserire la carta di credito per provare?", a: "No. La prova di 14 giorni è completa e non chiede nessuna carta. Alla scadenza decidi tu se abbonarti." },
        { q: "Quanti dipendenti posso gestire?", a: "Illimitati, in tutti i piani. A differenza di altre app, il prezzo di IL-Report è fisso: non paghi per ogni dipendente aggiunto." },
        { q: "Serve installare qualcosa sul computer?", a: "No: dal PC si usa direttamente nel browser, comodissimo per l'ufficio. Sul telefono puoi installarla come app (Android, iPhone) e funziona anche offline." },
        { q: "I miei dati sono al sicuro?", a: "Ogni azienda ha i propri dati completamente isolati e cifrati in transito. Puoi richiedere l'eliminazione completa in qualsiasi momento." },
        { q: "Posso disdire quando voglio?", a: "Sì, l'abbonamento è mensile senza vincoli: si disdice in un clic dalla pagina Abbonamento." },
      ],
    },
    cta: {
      title: "Da oggi le ore si segnano da sole.",
      sub: "Attiva la prova gratuita: in 2 minuti la tua azienda è operativa, con i tuoi dipendenti e le tue commesse.",
      demo: "Prova la demo",
    },
    footer: { privacy: "Privacy", demo: "Demo" },
    docTitle: "IL-Report — Rapportini e ore di lavoro per imprese e cantieri",
  },
  app: {
    nav: {
      home: "Home", settimana: "Settimana", lista: "Lista Rapp", riepilogo: "Riepilogo",
      stampe: "Stampe ore dip.", statistiche: "Statistiche", importa: "Importa",
      dipendenti: "Dipendenti", commesse: "Commesse", clienti: "Clienti",
      "da-vidimare": "Da vidimare", "da-sistemare": "Da sistemare", risorse: "Risorse", programma: "Programmi giornalieri", quadro: "Dashboard", "controllo-ore": "Controllo giornate", "dashboard-commesse": "Dash. commesse",
      utenti: "Utenti", cestino: "Cestino", impostazioni: "Impostazioni", aziende: "Aziende",
    },
    subtitle: "Rapportini interni di lavoro",
    logout: "Esci",
    pcHelp: {
      title: "Usala anche sul computer",
      sub: "Stesso account, stessi dati: quello che fai dal telefono lo ritrovi subito sul PC.",
      step1: "Sul computer apri Chrome o Edge",
      step2: "Vai all'indirizzo qui sotto (puoi copiarlo e inviartelo via email)",
      step3: "Accedi con la stessa email e password che usi sul telefono",
      step4: "Facoltativo: clicca l'icona \"Installa\" nella barra dell'indirizzo per averla come programma con icona sul desktop",
      copyBtn: "Copia indirizzo",
      copied: "Indirizzo copiato! Incollalo nel browser del computer",
    },
    logoutConfirmTitle: "Vuoi uscire?",
    logoutConfirmSub: "Dovrai accedere di nuovo per usare l'app.",
    logoutCancel: "Annulla",
    roles: { admin: "Admin", viewer: "Visualizzatore", capo_cantiere: "Capo cantiere", capo_officina: "Capo officina", user: "Utente" },
    trial: { label: "Prova gratuita", dayLeft: "giorno rimasto", daysLeft: "giorni rimasti", subscribe: "Abbonati ora" },
    expired: { sub: "Abbonamento scaduto", trial: "Prova scaduta", readonly: " — i dati sono in sola lettura.", activate: "Attiva il piano" },
    demoBanner: "🧪 MODALITÀ DEMO — dati di esempio isolati, si azzerano ogni 24 ore. Invio email disabilitato. Prova tutto liberamente!",
    week: {
      days: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
      kicker: "Vista settimanale", title: "Settimana",
      from: "Dal", to: "al", reports: "rapportini", reports_one: "rapportino", reports_other: "rapportini", hours: "ore",
      loadErr: "Impossibile caricare i rapportini",
      viewerMsg: "Account in sola visualizzazione: non puoi creare rapportini",
      scanAI: "Scansiona AI", thisWeek: "Questa settimana", loading: "Caricamento…",
      rappN: "Rapp. #", rows: "righe", rows_one: "riga", rows_other: "righe", none: "Nessun rapportino",
      open: "Apri", see: "Vedi", fill: "Compila",
      countTitle: "rapportini in questo giorno",
      addAnother: "Aggiungi un altro rapportino per questo giorno",
      fullList: "Lista completa",
      fullListSub: "Vedi tutti i rapportini in formato lista con filtri e ricerca.",
      goToList: "Vai alla lista",
    },
    rapp: {
      save: "Salva", saving: "Salvataggio…", print: "Stampa",
      saveNew: "Salva e nuovo (stessa data)", saveDup: "Salva e duplica al giorno dopo",
      saveFull: "Salva rapportino", addRiga: "Aggiungi riga",
      commessa: "Commessa", personale: "Personale", guida: "Guida", passegg: "Passegg.",
      lavoro: "Lavoro", tot: "Tot", note: "Note",
      copiaCommessa: "Copia {{code}} dalla riga sopra",
    },
    settings: {
      kicker: "Amministrazione", title: "Impostazioni email",
      sub: "Configura i destinatari delle email automatiche e l'oggetto di default.",
    },
    riep: {
      kicker: "Statistiche", title: "Riepilogo ore per commessa",
      sub: "Aggrega le ore lavorate per commessa e dipendente, filtra per periodo.",
      exportCsv: "Esporta CSV", tutte: "Tutte le commesse",
      dal: "Dal", al: "Al", loading: "Caricamento…",
      noData: "Nessun dato per i filtri selezionati",
      stats: { commesse: "Commesse", dipendenti: "Dipendenti", oreTotali: "Ore totali", voci: "Voci" },
      officina: "OFFICINA", cantiere: "CANTIERE",
      tab: { dipendente: "Dipendente", totale: "Totale", giorni: "Giorni", totCommessa: "Totale commessa" },
      exp: {
        title: "Export per gestionale (.xlsx)",
        desc1: "Genera l'Excel filtrato per il range selezionato sopra (data finale = ",
        desc2: "). Include 1 riga per ogni commessa con totale ore e costo orario.",
        btn: "Scarica Excel",
        lastLabel: "Ultima esportazione al gestionale",
        lastCovers: "copre le ore fino al",
        lastDone: "fatta il",
        lastNone: "Nessuna esportazione ancora effettuata",
      },
    },
    home: {
      lastExportTitle: "Ultima esportazione al gestionale",
      lastExportCovers: "copre le ore dei rapportini fino al",
      lastExportDone: "esportazione fatta il",
      lastExportNone: "Nessuna esportazione al gestionale ancora effettuata",
      greeting: "Ciao {{name}} 👋",
      oreSett: "Ore questa settimana",
      rappSett: "Rapportini settimana",
      daVidimare: "Da vidimare",
      daVidimareOre: "{{ore}} h questa settimana",
      ultimeCommesse: "Ultime commesse create",
      tipLabel: "Daily Boost · la frase del giorno",
      updatedOn: " — aggiornata il ",
      accessiTitle: "Accessi al software dall'ultima conferma",
      dlg: {
        pendingTitle: "Nuovi inserimenti da confermare",
        later: "Più tardi",
        openFix: "Apri \"Da sistemare\"",
        bozzaTitle: "Hai un rapportino in bozza",
        bozzaLeft: "Hai lasciato un rapportino a metà",
        savedOn: ", salvato il",
        bozzaQ: "Vuoi riprenderla o eliminarla e ricominciare da zero?",
        bozzaDelete: "Elimina, ricomincio da zero",
        bozzaResume: "Riprendi la bozza",
      },
      budgetTitle: "Commesse vicine al budget ore",
      vidTitle: "Vidimazioni recenti di altri amministratori",
      tiles: {
        nuovo: { l: "Nuovo rapportino", d: "Inserisci le ore di oggi" },
        settimana: { l: "Settimana", d: "Rapportini della settimana" },
        "lista-rapp": { l: "Lista Rapp", d: "Tutti i rapportini" },
        riepilogo: { l: "Riepilogo", d: "Ore per commessa + export" },
        "da-inviare": { l: "Da inviare", d: "Invia i rapportini a chi vidima" },
        "da-vidimare": { l: "Da vidimare", d: "Rapportini in attesa" },
        "da-sistemare": { l: "Da sistemare", d: "Conferme e anagrafica incompleta" },
        quadro: { l: "Dashboard aziendale", d: "Quadro in tempo reale: persone, mezzi, cantieri, scadenze" },
        programma: { l: "Programmi giornalieri", d: "Chi è dove ogni giorno: persone, mezzi, attrezzature, stampa A3" },
        risorse: { l: "Parco risorse", d: "Personale, mezzi, attrezzature, sedi" },
        "stampe-ore": { l: "Stampe ore", d: "PDF mensile dipendenti" },
        "controllo-ore": { l: "Controllo giornate", d: "Dipendenti senza ore: rapportini mancanti o assenze" },
        "dashboard-commesse": { l: "Dashboard commesse", d: "Avanzamento ore vs budget delle commesse recenti" },
        statistiche: { l: "Statistiche", d: "Analisi commesse e dipendenti" },
        importa: { l: "Importa", d: "Scansiona rapportini cartacei" },
        dipendenti: { l: "Dipendenti", d: "Anagrafica operai" },
        commesse: { l: "Commesse", d: "Codici e budget" },
        clienti: { l: "Clienti", d: "Anagrafica e stabilimenti" },
        impostazioni: { l: "Impostazioni", d: "Configurazione app" },
      },
    },
    daInviare: {
      title: "Da inviare",
      subtitle: "I tuoi rapportini dal 01/08/2026: seleziona quelli non ancora inviati e spediscili in blocco a chi li vidima.",
      loading: "Caricamento...",
      loadError: "Impossibile caricare i rapportini",
      sectionDaInviare: "Non ancora inviati",
      sectionInviati: "Già inviati",
      emptyDaInviare: "Tutto inviato! Nessun rapportino in attesa di invio.",
      emptyInviati: "Nessun rapportino inviato finora.",
      selectAll: "Seleziona tutti",
      deselectAll: "Deseleziona",
      sendBtn: "Invia selezionati ({{n}})",
      sentOk: "Link di download (valido 24 ore) del rapportino inviato a: {{dest}}",
      sentZipOk: "Link di download (valido 24 ore) di {{n}} rapportini (ZIP {{zip}}) inviato a: {{dest}}",
      previewTitleZip: "Anteprima invio: link per scaricare {{n}} rapportini (ZIP)",
      previewTitleSingle: "Anteprima invio: link per scaricare 1 rapportino (PDF)",
      previewLinkInfo: "L'email NON contiene allegati: ha un pulsante per scaricare i PDF. Il link scade dopo {{h}} ore.",
      previewTo: "Destinatari:",
      previewSubject: "Oggetto:",
      previewCancel: "Annulla",
      previewConfirm: "Conferma e invia ({{n}})",
      sentFail: "Invio non riuscito: riprova",
      demoBlock: "In modalità demo l'invio email è disabilitato",
      rapNum: "Rapportino N° {{n}}",
      vidimato: "vidimato",
      inviatoIl: "Inviato il {{d}}",
      nonInviato: "Da inviare",
    },
    stats: {
      title: "Statistiche", print: "Stampa",
      perCommessa: "Per commessa", perDipendenti: "Per dipendenti",
      storicoTab: "Storico anni",
      storicoTitle: "Storico ore 2021-2025",
      storicoSub: "Ore totali dei prospetti annuali pre-app (solo statistiche: nessun dipendente o commessa del periodo è stato importato).",
      storicoInCorso: "in corso",
      storicoDettaglio: "Dettaglio anno",
      storicoEmpty: "Nessun dato storico disponibile",
      storicoCommessa: "Commessa",
      storicoCantiere: "Cantiere",
      storicoOfficina: "Officina",
      storicoTotale: "Ore totali",
      storicoOrd: "Ordinarie",
      storicoStra: "Straordinari",
      storicoViaggio: "Viaggio",
      storicoNota: "Top 15 commesse per ore su {{n}} commesse totali dell'anno.",
      ricercaTitle: "🔎 Ricerca archivio storico",
      ricercaSub: "Cerca un operaio o una commessa nell'archivio del vecchio gestionale (01/01/2021 → 31/05/2026): ore totali, andamento per anno e dettaglio.",
      ricercaOperaio: "Operaio",
      ricercaOperaioPh: "Es. Costea Cristian",
      ricercaCommessa: "Commessa",
      ricercaCommessaPh: "Es. EG-21-055",
      ricercaBtn: "Cerca",
      ricercaTot: "Ore totali",
      ricercaRighe: "Giornate/righe",
      ricercaPeriodo: "Periodo",
      ricercaPerCommessa: "Ore per commessa",
      ricercaPerOperaio: "Ore per operaio",
      ricercaNoRes: "Nessun risultato nell'archivio storico per questa ricerca.",
      ricercaPdfBtn: "Stampa PDF",
      ricercaFonte: "Fonte: archivio vecchio gestionale (dettaglio giornaliero fino al 31/05/2026). Le ore dal 01/06/2026 sono nei rapportini dell'app.",
      commessaOpt: "Commessa (opzionale)",
      removeFilter: "Rimuovi filtro commessa",
      onlyVidim: "Solo rapportini vidimati",
      selEmp: "Seleziona dipendenti", of: "di",
      searchEmp: "Cerca dipendente…", all: "Tutti", none: "Nessuno",
      noEmpFound: "Nessun dipendente trovato",
      onlyAdmins: "Statistiche disponibili solo per admin e visualizzatori.",
      rapportini: "Rapportini", giorni: "Giorni", dipendenti: "Dipendenti",
      oreTotali: "Ore totali", caldo: "Caldo", notturne: "Notturne",
      costoManodopera: "Costo manodopera",
      esclusi: "esclusi materiali e altri costi",
      totPerDip: "Totali per dipendente", totPerDip2: "Totale per dipendente",
      dettaglio: "Dettaglio occorrenze",
      data: "Data", note: "Note", totale: "Totale",
      totCommessa: "Totale commessa",
      selectedSummary: "Riepilogo ore — {{count}} selezionati",
      periodo: "Periodo", inizio: "inizio", oggi: "oggi",
      filtroCommessa: "Filtrato per commessa:",
      commesse: "Commesse",
    },
    list: {
      kicker: "Dashboard", title: "Rapportini",
      exportCsv: "Esporta CSV", nuovo: "Nuovo",
      perSettimana: "Per settimana", intervallo: "Intervallo personalizzato",
      tuttiRapp: "Tutti i rapportini", ordina: "Ordina per…",
      sort: {
        dataDesc: "Data ↓ (più recenti)", dataAsc: "Data ↑ (più vecchi)",
        numDesc: "Numero rapp. ↓", numAsc: "Numero rapp. ↑",
        cmAsc: "Commessa ↑ (codice)", cmDesc: "Commessa ↓",
        clAsc: "Cliente A→Z", clDesc: "Cliente Z→A",
      },
      reset: "Reset filtri", cerca: "Cerca",
      searchPh: "Commessa, dipendente, note…",
      dataPrecisa: "Data precisa",
      dipendente: "Dipendente", tuttiDip: "Tutti i dipendenti",
      tutte: "Tutte", tutti: "Tutti",
      soloMiei: "Solo i miei rapportini",
      soloMieiSub: "(mostra solo i rapportini che ho creato io)",
      settimana: "Settimana", da: "Da", a: "A",
      statRapp: "Rapportini", statOre: "Ore totali",
      statCommesse: "Commesse coinvolte", statDip: "Dipendenti coinvolti",
      daVidimare: "da vidimare",
      vidimate: "vidimate", daApprovare: "da approvare",
      emptyTitle: "Nessun rapportino trovato",
      emptySub: "Prova ad ampliare l'intervallo di date o resettare i filtri.",
      nuovoRapp: "Nuovo rapportino",
      giorni: "giorni", vidimato: "Vidimato", daVidimareBadge: "Da vidimare",
      nessunaCommessa: "Nessuna commessa",
      oreTotLower: "ore totali", byCreator: "da",
      vidima: "Vidima", modifica: "Modifica", apri: "Apri",
      vidimaTutti: "Vidima tutti",
      annullaSel: "Annulla selezione", vidimaSel: "Vidima selezionati",
      selCount: "{{count}} selezionati",
      unvidTitle: "{{count}} rapportini non vidimati",
      unvidSub: "Vengono mostrati con badge \"Da vidimare\" ma NON entrano nei totali ufficiali (ore dipendenti, riepiloghi, stampe). Vidima per ufficializzarli.",
      bozzeTitle: "{{count}} bozze in sospeso",
      tuaBozza: "La tua bozza", bozzaDi: "Bozza di",
      riprendi: "Riprendi", elimina: "Elimina",
    },
    tour: {
      profileTitle: "Tutorial dell'app",
      profileSub: "Rivedi la guida quando vuoi: completa o sintetica, scegli tu.",
      profileBtn: "Rivedi il tutorial",
      welcomeTitle: "Benvenuto in IL-Report{{name}}! 👋",
      welcomeSub: "L'app per gestire le ore della tua squadra: rapportini, commesse, vidimazioni e stampe. Come preferisci iniziare?",
      fullBtn: "Tutorial completo",
      fullBtnSub: "Ti spiego ogni voce, dall'inserimento dei rapportini al risultato finale (≈3 minuti)",
      shortBtn: "Tutorial sintetico",
      shortBtnSub: "Solo l'essenziale, in 1 minuto",
      skip: "Salta per ora",
      dontShow: "Non mostrarmelo più al prossimo accesso",
      back: "Indietro", next: "Avanti", start: "Inizia a usare l'app",
      rewatchHint: "Puoi rivederlo quando vuoi dal tuo Profilo.",
      fullBase: [
        { t: "La tua Home", x: "Dalla Home raggiungi tutto con un tocco: Nuovo rapportino, Settimana, Lista, Riepilogo. In alto vedi le ore e i rapportini di questa settimana." },
        { t: "Nuovo rapportino: data e giorni", x: "Tocca \"Nuovo rapportino\": l'app propone la data di oggi e il numero progressivo. Puoi aggiungere più giorni nello stesso rapportino, uno sotto l'altro." },
        { t: "Le righe: commessa e personale", x: "In ogni riga scegli la commessa (basta digitare il codice) e il dipendente. I nomi si completano da soli mentre scrivi, e una nuova riga appare in automatico." },
        { t: "Le ore: guida, passeggero, lavoro", x: "Inserisci le ore divise per tipo: Guida, Passeggero e Lavoro (più Caldo e Notturne per l'officina). Il totale della riga e del giorno si calcola da solo." },
        { t: "Note e regole delle commesse", x: "Alcune commesse richiedono note obbligatorie (minimo 10 caratteri): l'app te lo ricorda al salvataggio. Se una commessa è chiusa, dalle date successive alla chiusura non si inseriscono più ore." },
        { t: "Salva, bozza e offline", x: "Salva quando hai finito. Se ti manca qualcosa, salva come bozza e riprendila dalla Lista. Funziona anche senza connessione: i dati si sincronizzano appena torni online." },
        { t: "Commesse al volo", x: "Codice commessa nuovo? Te la facciamo creare al volo con descrizione e cliente, senza uscire dal rapportino. La gemella -OFF per l'officina si crea in automatico." },
        { t: "Settimana e Lista", x: "Nella \"Settimana\" vedi a colpo d'occhio i giorni compilati e quelli mancanti. Nella \"Lista\" filtri per commessa, dipendente o periodo e cerchi nelle note." },
      ],
      fullAdmin: [
        { t: "Vidima: rendi ufficiali le ore", x: "In \"Da vidimare\" approvi i rapportini della squadra: solo le ore vidimate entrano nei totali ufficiali. In \"Da sistemare\" trovi anagrafiche incomplete e conferme in sospeso." },
        { t: "Riepilogo ed export al gestionale", x: "Nel \"Riepilogo\" vedi le ore aggregate per commessa e scarichi l'Excel per il gestionale. La card in Home ti ricorda fino a quale data copre l'ultima esportazione." },
        { t: "Stampe ore dipendenti", x: "In \"Stampe ore dip.\" generi il PDF mensile delle ore di ogni dipendente: pronto per le buste paga o per l'archivio." },
        { t: "Statistiche e budget ore", x: "In \"Statistiche\" analizzi ore e costo manodopera per commessa o per dipendente. Imposta un budget ore sulle commesse: ti avvisiamo all'80%." },
        { t: "Commesse e utenti", x: "Dall'elenco \"Commesse\" gestisci budget, note obbligatorie e chiusura delle commesse. Da \"Utenti\" inviti la squadra e imposti ruoli e permessi." },
      ],
      fullUser: [
        { t: "Invia e lascia fare a noi", x: "Quando salvi un rapportino, l'amministratore lo riceve e lo vidima. Puoi modificarlo finché non è stato vidimato." },
      ],
      shortBase: [
        { t: "Compila il rapportino", x: "Da \"Nuovo rapportino\" inserisci data, commessa, personale e ore. Le righe si aggiungono da sole mentre scrivi. Funziona anche offline." },
        { t: "La tua settimana a colpo d'occhio", x: "Nella vista \"Settimana\" vedi subito i giorni compilati e quelli mancanti. Un tocco su \"Compila\" e sei dentro il rapportino del giorno." },
        { t: "Commesse al volo", x: "Digita un codice commessa nuovo direttamente nel rapportino: se non esiste, ti proponiamo di crearla al volo. Zero interruzioni." },
      ],
      shortAdmin: [
        { t: "Vidima e tieni tutto in ordine", x: "In \"Da vidimare\" approvi i rapportini della squadra. In \"Da sistemare\" trovi anagrafiche incomplete e conferme in sospeso." },
        { t: "Stampe, statistiche e budget", x: "PDF mensili delle ore per dipendente, statistiche per commessa, export Excel per il gestionale e budget ore con avviso all'80%." },
      ],
      shortUser: [
        { t: "Invia e lascia fare a noi", x: "Quando salvi un rapportino, l'amministratore lo riceve e lo vidima. Puoi modificarlo finché non è stato vidimato." },
      ],
      end: { t: "Il risultato finale 🚀", x: "Dalla carta al digitale: rapportini ordinati, ore vidimate, PDF ed Excel pronti per il gestionale. Puoi rivedere questo tutorial quando vuoi dal tuo Profilo. Buon lavoro!" },
    },
    set: {
      autoSend: "Invio automatico al salvataggio",
      autoSendSub: "Quando attivo, ogni nuovo rapportino salvato viene inviato in PDF agli amministratori con la spunta \"Riceve i rapportini via email\" e alla lista dei destinatari extra sotto (indirizzi senza account, es. commercialista).",
      subject: "Oggetto email (template)",
      subjectVars: "Variabili disponibili:",
      recipients: "Destinatari (To)",
      add: "Aggiungi",
      noRecipients: "Nessun destinatario configurato",
      provider: "Configurazione provider email",
      formatoTitle: "🏷 Formato codice commessa",
      exportTitle: "Export gestionale — costo orario di default",
      exportSub: "Valore in €/h usato nella colonna \"Costo\" dell'Excel scaricabile dalla pagina Riepilogo.",
      overtimeTitle: "Soglia avviso ore eccessive",
      overtimeSub: "L'app mostra un avviso quando un dipendente supera questo numero di ore in un singolo giorno. Default: 13 ore.",
      orePerGiorno: "ore / giorno",
      recentTitle: "Commesse recenti in Home",
      recentSub: "Quante \"ultime commesse create\" mostrare nella striscia della Home. Default: 10.",
      commesseUnit: "commesse",
      capTitle: "8 ore MAX",
      capSub: "Se attiva, tutti gli utenti — admin compresi — vedono al massimo 8 ore per dipendente al giorno ovunque nell'app (liste, riepiloghi, PDF, Excel, email) e inseriscono solo ore intere. Interruttore non distruttivo: i dati nel database non vengono mai modificati.",
      notifyTitle: "✉ Notifica admin per rapportini non vidimati",
      notifySub: "Se attiva, quando un capo cantiere salva un rapportino gli amministratori con la spunta \"Riceve i rapportini via email\" ricevono un avviso con il solo link a \"Da vidimare\" (nessun PDF allegato).",
      backupTitle: "🛡 Backup automatico ore via email",
      backupSub: "Ricevi su {{email}} un Excel con TUTTE le ore: dettaglio completo, totali per commessa e ore mensili dipendente per dipendente.",
      backupFreq: "Frequenza",
      backupWeekly: "Ogni settimana",
      backupMonthly: "Ogni mese",
      backupLast: "Ultimo backup inviato",
      backupNever: "mai",
      backupNow: "Invia backup ora",
      backupSending: "Invio in corso…",
      backupSentOk: "Backup inviato! Controlla la tua email",
      backupEmpty: "Nessuna ora registrata da salvare",
      backupErr: "Invio backup non riuscito",
      upperTitle: "Visualizza tutto in MAIUSCOLO",
      upperSub: "Se attiva, tutti i testi vengono mostrati in MAIUSCOLO nell'interfaccia. I dati salvati restano invariati.",
      maintTitle: "Manutenzione app (cache PWA)",
      tipsTitle: "✨ Frasi del giorno (Daily Boost)",
      tipsSub: "{{active}} frasi attive su {{total}}: ruotano una al giorno nella Home di chi ha la frase abilitata. Modifica, disattiva o aggiungi le tue.",
      tipsAdd: "Aggiungi frase",
      tipsShow: "Mostra le {{total}} frasi",
      tipsHide: "Nascondi frasi",
      tipsEdit: "Modifica frase",
      tipsReset: "Ripristina originali",
      tipsResetConfirm: "Ripristinare le 65 frasi di serie? Le modifiche e le frasi personalizzate verranno eliminate.",
      tipsResetDone: "Frasi di serie ripristinate",
      tipsDeleteConfirm: "Eliminare questa frase?",
      tipsSearch: "Cerca tra le frasi…",
      tipsNone: "Nessuna frase trovata",
      tipsCustom: "personalizzata",
      tipsTextIt: "Testo (italiano)",
      tipsTextEn: "Testo (inglese) — facoltativo",
      tipsTextEnHint: "Se vuoto, agli utenti in inglese viene mostrato il testo italiano.",
      tipsRequired: "Il testo della frase è obbligatorio",
      tipsErr: "Operazione non riuscita",
      tipsCancel: "Annulla",
      tipsSave: "Salva",
      logoTitle: "🏢 Azienda: nome e logo",
      logoSub: "Il nome compare in Home; il logo (opzionale) in Home e in alto a destra sui PDF dei rapportini, senza modificare il layout delle stampe. Consigliato: PNG con sfondo trasparente.",
      companyNameLabel: "Nome azienda mostrato in Home",
      companyNamePh: "Es. Europe Glass",
      prefixRenameConfirm: "Stai cambiando la sigla commesse da {{old}} a {{new}}.\n\nTUTTE le commesse e i rapportini esistenti verranno rinominati automaticamente (es. {{old}}-01-001 → {{new}}-01-001).\n\nContinuare?",
      prefixRenamed: "Sigla aggiornata: {{commesse}} commesse e {{rapportini}} rapportini rinominati da {{old}} a {{new}}",
      logoEmpty: "Nessun logo",
      logoUpload: "Carica logo",
      logoChange: "Cambia logo",
      logoRemove: "Rimuovi",
      logoSaved: "Logo salvato",
      logoRemoved: "Logo rimosso",
      logoBadFile: "File non valido: usa un'immagine PNG o JPG",
      maintSub: "Se vedi dati vecchi o impostazioni non aggiornate, usa questo pulsante per svuotare completamente la cache locale e ricaricare. Operazione sicura: nessun rapportino viene cancellato.",
      maintBtn: "Svuota cache e ricarica",
      saveBtn: "Salva impostazioni",
      lastExportFooter: "Ultima esportazione gestionale:",
      saved: "Impostazioni salvate",
      saveErr: "Salvataggio non riuscito",
    },
    setup: {
      title: "🚀 Iniziamo! Configura la tua azienda",
      titleDone: "Configurazione completata!",
      sub: "{{done}} passi su {{total}} completati — segui la guida e in pochi minuti sei operativo.",
      subDone: "La tua azienda è pronta: da qui in poi è tutta strada in discesa.",
      stepAzienda: "Registra la tua azienda (il nome basta, il resto puoi aggiungerlo dopo)",
      stepAdmin: "Crea il profilo amministratore",
      stepDipendente: "Aggiungi il tuo primo dipendente",
      stepCommessa: "Crea la tua prima commessa",
      stepRapportino: "Inserisci il tuo primo rapportino con le ore",
      ctaDipendente: "Aggiungi",
      ctaCommessa: "Crea",
      ctaRapportino: "Inserisci",
      finishBtn: "Perfetto, chiudi la guida",
    },
    intro: {
      badge: "Presentazione · 60 secondi",
      skip: "Salta",
      tapHint: "Tocca per andare avanti",
      startBtn: "Iniziamo",
      welcomeTitle: "Benvenuto in IL-Report",
      welcomeSub: "Le ore della tua squadra, sotto controllo: rapportini, commesse e statistiche in un'unica app.",
      rapportiniTitle: "Rapportini in pochi secondi",
      rapportiniSub: "Commessa, personale e ore: la tua squadra compila dal telefono, anche offline in cantiere.",
      rowOperaio: "Operaio",
      vidimaTitle: "Vidimazione e controllo",
      vidimaSub: "L'admin approva i rapportini con un tocco: tutto tracciato, niente più fogli persi.",
      vidimaBadge: "Rapportino",
      statsTitle: "Statistiche, stampe ed export",
      statsSub: "Ore per commessa e dipendente, PDF pronti da inviare e l'export per il gestionale.",
      boostTitle: "Squadra motivata e sicura",
      boostSub: "Ogni giorno una frase su resa, leadership e sicurezza in cantiere — personalizzabile dall'admin.",
      boostQuote: "La sicurezza non è un costo: è la firma di un capo che riporta a casa la squadra, intera, ogni sera.",
      goTitle: "Pronti? Si parte!",
      goSub: "Registra la tua azienda, aggiungi il primo dipendente e crea il primo rapportino: la guida ti accompagna passo passo.",
      profileTitle: "Presentazione dell'app (60 secondi)",
      profileSub: "Rivedi la presentazione animata mostrata al primo accesso.",
      profileBtn: "Rivedi presentazione",
    },
  },
};

const en = {
  common: {
    accedi: "Sign in",
    provaGratis: "Free trial",
    email: "Email",
    password: "Password",
  },
  auth: {
    tagline: "Your crew's hours, under control",
    regTitle: "Create your company",
    regSub: "Free 14-day trial, no credit card. Your company's data is private and isolated.",
    regAzienda: "Company name *",
    regAziendaPh: "e.g. Smith Contractors Ltd",
    regNome: "Your full name *",
    regNomePh: "e.g. John Smith",
    regPassword: "Password * (min. 6 characters)",
    regLoading: "Creating…",
    emailRequired: "Enter your email",
    emailInvalid: "Invalid email: check the address (e.g. name@company.com)",
    pwdRequired: "Enter your password",
    pwdMin: "Password must be at least 6 characters",
    fieldRequired: "Fill out this field",
    regSubmit: "Start your free trial",
    regBack: "Already have an account? Sign in",
    loginSub: "Enter your credentials to continue.",
    loginLoading: "Signing in…",
    loginDemo: "🧪 Try the demo — no sign-up",
    loginRegister: "New company? Try free for 14 days →",
    heroA: "Your crew's hours,",
    heroB: "always under control.",
  },
  landing: {
    nav: { funzioni: "Features", ovunque: "Site & Office", prezzi: "Pricing", faq: "FAQ" },
    hero: {
      kicker: "For contractors, job sites and workshops",
      h1a: "Your crew's hours,",
      h1b: "always under control.",
      sub: "No more loose paper sheets and hours pieced together at month end: foremen fill in daily work reports from their phone in 30 seconds — even offline — while the office approves, prints and archives from a computer. Plus, a daily motivational quote fires up your foremen and boosts your crew's output.",
      cta: "Try free for 14 days",
      demo: "See the demo",
      nocard: "No credit card required · Cancel anytime",
      badges: ["UNLIMITED EMPLOYEES", "WORKS OFFLINE", "DAILY MOTIVATION", "ANDROID · IPHONE · PC", "AUTOMATIC PDF & EMAIL"],
    },
    ovunque: {
      kicker: "One app, two ways to use it",
      title: "Phone on the job site, PC in the office.",
      sub: "Same data, always in sync: everyone works from the most convenient device.",
      mobileTitle: "On site, from the phone",
      mobile: [
        "Foremen log hours right after the shift, in 30 seconds",
        "Works even with no signal: it syncs automatically later",
        "Download it from the Google Play Store on Android, or install from the browser on iPhone",
      ],
      pcTitle: "In the office, from the computer",
      pc: [
        "Same account as the phone: reports filled on site appear instantly on the PC",
        "Straight from the browser with nothing to install — or click \"Install\" in Chrome or Edge and it becomes a desktop program with its own icon",
        "Approvals, PDF timesheets, statistics and Excel exports from your desk, with a big screen and keyboard",
      ],
    },
    funzioni: {
      kicker: "Everything you need",
      title: "From work report to payroll, paper-free.",
      items: [
        { title: "Work reports in 30 seconds", desc: "Log the whole crew's hours from the phone, even for several days at once. The form fills itself with your employees and jobs." },
        { title: "Works without internet", desc: "Signal comes and goes on site: IL-Report saves everything on the device and syncs automatically when you're back online." },
        { title: "Office approval", desc: "Admins review and approve work reports in one click. Everything tracked: who, what, when." },
        { title: "Automatic PDF & email", desc: "Monthly timesheets per employee and work reports sent by email as PDF, ready for your accountant and payroll." },
        { title: "Jobs & hour budgets", desc: "Every hour lands on the right job. Hour budgets with alerts when you approach the limit: no more surprises at month end." },
        { title: "Instant statistics", desc: "Hours by job, by employee, by period. You always know where your crew's work goes." },
        { title: "Daily motivation", desc: "Not just management: a daily quote crafted for site and workshop foremen fires up whoever leads the crew and boosts people's output, one day at a time." },
      ],
    },
    prezzi: {
      kicker: "Simple pricing",
      title: "Flat price. Unlimited employees.",
      sub: "Other apps charge per employee: with a 20-man crew you'd pay €100+ a month. With IL-Report the price never changes, whether you have 5 or 50 employees.",
      featured: "Most popular",
      alMese: "/month + VAT",
      senzaCarta: "No credit card required",
      baseClaim: "For tidy work reports and hours",
      base: ["Unlimited employees and reports", "Works offline on site", "Office approval", "Monthly PDF timesheets", "500 emails per month included"],
      proClaim: "For control and analysis too",
      pro: ["Everything in Base, plus:", "Full statistics by job and employee", "Hour budgets with overrun alerts", "Exports for your ERP and accountant", "Unlimited emails"],
      note1: "Secure payment by card or PayPal",
      note2: "Monthly, no commitment",
      note3: "Instant activation",
    },
    faq: {
      kicker: "Frequently asked questions",
      title: "Everything clear before you start.",
      items: [
        { q: "Do I need a credit card to try it?", a: "No. The 14-day trial is fully featured and asks for no card. When it ends, you decide whether to subscribe." },
        { q: "How many employees can I manage?", a: "Unlimited, on every plan. Unlike other apps, IL-Report's price is flat: you don't pay for each employee you add." },
        { q: "Do I need to install anything on the computer?", a: "No: on a PC it runs straight in the browser, perfect for the office. On phones you can install it as an app (Android, iPhone) and it works offline too." },
        { q: "Is my data safe?", a: "Each company's data is fully isolated and encrypted in transit. You can request complete deletion at any time." },
        { q: "Can I cancel anytime?", a: "Yes, the subscription is monthly with no commitment: cancel in one click from the Subscription page." },
      ],
    },
    cta: {
      title: "From today, hours log themselves.",
      sub: "Start your free trial: your company is up and running in 2 minutes, with your employees and your jobs.",
      demo: "Try the demo",
    },
    footer: { privacy: "Privacy", demo: "Demo" },
    docTitle: "IL-Report — Work reports and crew hours for contractors",
  },
  app: {
    nav: {
      home: "Home", settimana: "Week", lista: "Reports", riepilogo: "Summary",
      stampe: "Timesheets", statistiche: "Statistics", importa: "Import",
      dipendenti: "Employees", commesse: "Jobs", clienti: "Clients",
      "da-vidimare": "To approve", "da-sistemare": "To fix", risorse: "Resources", programma: "Daily schedules", quadro: "Dashboard", "controllo-ore": "Missing days", "dashboard-commesse": "Jobs dashboard",
      utenti: "Users", cestino: "Trash", impostazioni: "Settings", aziende: "Companies",
    },
    subtitle: "Internal daily work reports",
    logout: "Log out",
    pcHelp: {
      title: "Use it on your computer too",
      sub: "Same account, same data: everything you do on the phone shows up instantly on the PC.",
      step1: "On the computer, open Chrome or Edge",
      step2: "Go to the address below (you can copy it and email it to yourself)",
      step3: "Sign in with the same email and password you use on the phone",
      step4: "Optional: click the \"Install\" icon in the address bar to get it as a desktop program with its own icon",
      copyBtn: "Copy address",
      copied: "Address copied! Paste it in your computer's browser",
    },
    logoutConfirmTitle: "Log out?",
    logoutConfirmSub: "You'll need to sign in again to use the app.",
    logoutCancel: "Cancel",
    roles: { admin: "Admin", viewer: "Viewer", capo_cantiere: "Site foreman", capo_officina: "Workshop foreman", user: "User" },
    trial: { label: "Free trial", dayLeft: "day left", daysLeft: "days left", subscribe: "Subscribe now" },
    expired: { sub: "Subscription expired", trial: "Trial expired", readonly: " — data is read-only.", activate: "Activate plan" },
    demoBanner: "🧪 DEMO MODE — isolated sample data, resets every 24 hours. Email sending disabled. Try everything freely!",
    week: {
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      kicker: "Weekly view", title: "Week",
      from: "From", to: "to", reports: "reports", reports_one: "report", reports_other: "reports", hours: "hours",
      loadErr: "Could not load work reports",
      viewerMsg: "View-only account: you cannot create work reports",
      scanAI: "AI Scan", thisWeek: "This week", loading: "Loading…",
      rappN: "Rep. #", rows: "rows", rows_one: "row", rows_other: "rows", none: "No work report",
      open: "Open", see: "See", fill: "Fill in",
      countTitle: "reports on this day",
      addAnother: "Add another work report for this day",
      fullList: "Full list",
      fullListSub: "See all work reports as a list with filters and search.",
      goToList: "Go to the list",
    },
    rapp: {
      save: "Save", saving: "Saving…", print: "Print",
      saveNew: "Save & new (same date)", saveDup: "Save & duplicate to next day",
      saveFull: "Save report", addRiga: "Add row",
      commessa: "Job", personale: "Crew", guida: "Drive", passegg: "Passenger",
      lavoro: "Work", tot: "Tot", note: "Notes",
      copiaCommessa: "Copy {{code}} from the row above",
    },
    settings: {
      kicker: "Administration", title: "Email settings",
      sub: "Configure the recipients of automatic emails and the default subject.",
    },
    riep: {
      kicker: "Statistics", title: "Hours summary by job",
      sub: "Aggregates hours worked by job and employee, filter by period.",
      exportCsv: "Export CSV", tutte: "All jobs",
      dal: "From", al: "To", loading: "Loading…",
      noData: "No data for the selected filters",
      stats: { commesse: "Jobs", dipendenti: "Employees", oreTotali: "Total hours", voci: "Entries" },
      officina: "WORKSHOP", cantiere: "SITE",
      tab: { dipendente: "Employee", totale: "Total", giorni: "Days", totCommessa: "Job total" },
      exp: {
        title: "ERP export (.xlsx)",
        desc1: "Generates the Excel filtered by the range selected above (final date = ",
        desc2: "). Includes 1 row per job with total hours and hourly cost.",
        btn: "Download Excel",
        lastLabel: "Last ERP export",
        lastCovers: "covers hours up to",
        lastDone: "done on",
        lastNone: "No export made yet",
      },
    },
    home: {
      lastExportTitle: "Last ERP export",
      lastExportCovers: "covers work report hours up to",
      lastExportDone: "export made on",
      lastExportNone: "No ERP export made yet",
      greeting: "Hi {{name}} 👋",
      oreSett: "Hours this week",
      rappSett: "Reports this week",
      daVidimare: "To approve",
      daVidimareOre: "{{ore}} h this week",
      ultimeCommesse: "Latest jobs created",
      tipLabel: "Daily Boost · quote of the day",
      updatedOn: " — updated on ",
      accessiTitle: "Logins since last confirmation",
      dlg: {
        pendingTitle: "New entries to confirm",
        later: "Later",
        openFix: "Open \"To fix\"",
        bozzaTitle: "You have a draft report",
        bozzaLeft: "You left a work report half done",
        savedOn: ", saved on",
        bozzaQ: "Do you want to resume it, or delete it and start over?",
        bozzaDelete: "Delete, start over",
        bozzaResume: "Resume draft",
      },
      budgetTitle: "Jobs close to their hours budget",
      vidTitle: "Recent approvals by other administrators",
      tiles: {
        nuovo: { l: "New work report", d: "Enter today's hours" },
        settimana: { l: "Week", d: "This week's reports" },
        "lista-rapp": { l: "Reports", d: "All work reports" },
        riepilogo: { l: "Summary", d: "Hours by job + export" },
        "da-inviare": { l: "To send", d: "Email reports to approvers" },
        "da-vidimare": { l: "To approve", d: "Reports awaiting approval" },
        "da-sistemare": { l: "To fix", d: "Confirmations and incomplete records" },
        quadro: { l: "Company dashboard", d: "Live overview: people, vehicles, sites, deadlines" },
        programma: { l: "Daily schedules", d: "Who is where each day: people, vehicles, equipment, A3 print" },
        risorse: { l: "Resources", d: "People, vehicles, equipment, sites" },
        "stampe-ore": { l: "Timesheets", d: "Monthly employee PDF" },
        "controllo-ore": { l: "Missing days", d: "Employees without hours: missing reports or absences" },
        "dashboard-commesse": { l: "Jobs dashboard", d: "Hours vs budget progress of recent jobs" },
        statistiche: { l: "Statistics", d: "Job and employee analysis" },
        importa: { l: "Import", d: "Scan paper reports" },
        dipendenti: { l: "Employees", d: "Worker records" },
        commesse: { l: "Jobs", d: "Codes and budgets" },
        clienti: { l: "Clients", d: "Clients and plants" },
        impostazioni: { l: "Settings", d: "App configuration" },
      },
    },
    daInviare: {
      title: "To send",
      subtitle: "Your reports from 01/08/2026: select the ones not sent yet and email them in bulk to the approvers.",
      loading: "Loading...",
      loadError: "Could not load reports",
      sectionDaInviare: "Not sent yet",
      sectionInviati: "Already sent",
      emptyDaInviare: "All sent! No reports waiting.",
      emptyInviati: "No reports sent yet.",
      selectAll: "Select all",
      deselectAll: "Deselect",
      sendBtn: "Send selected ({{n}})",
      sentOk: "Download link (valid 24 hours) for the report sent to: {{dest}}",
      sentZipOk: "Download link (valid 24 hours) for {{n}} reports (ZIP {{zip}}) sent to: {{dest}}",
      previewTitleZip: "Send preview: link to download {{n}} reports (ZIP)",
      previewTitleSingle: "Send preview: link to download 1 report (PDF)",
      previewLinkInfo: "The email has NO attachments: it contains a button to download the PDFs. The link expires after {{h}} hours.",
      previewTo: "Recipients:",
      previewSubject: "Subject:",
      previewCancel: "Cancel",
      previewConfirm: "Confirm and send ({{n}})",
      sentFail: "Sending failed: try again",
      demoBlock: "Email sending is disabled in demo mode",
      rapNum: "Report No. {{n}}",
      vidimato: "approved",
      inviatoIl: "Sent on {{d}}",
      nonInviato: "To send",
    },
    stats: {
      title: "Statistics", print: "Print",
      perCommessa: "By job", perDipendenti: "By employee",
      storicoTab: "Yearly history",
      storicoTitle: "Hours history 2021-2025",
      storicoSub: "Total hours from pre-app yearly reports (statistics only: no employees or jobs from that period were imported).",
      storicoInCorso: "ongoing",
      storicoDettaglio: "Year detail",
      storicoEmpty: "No historical data available",
      storicoCommessa: "Job",
      storicoCantiere: "Site",
      storicoOfficina: "Workshop",
      storicoTotale: "Total hours",
      storicoOrd: "Ordinary",
      storicoStra: "Overtime",
      storicoViaggio: "Travel",
      storicoNota: "Top 15 jobs by hours out of {{n}} total jobs that year.",
      ricercaTitle: "🔎 Historical archive search",
      ricercaSub: "Search a worker or a job in the old management-system archive (01/01/2021 → 31/05/2026): total hours, yearly trend and detail.",
      ricercaOperaio: "Worker",
      ricercaOperaioPh: "e.g. Costea Cristian",
      ricercaCommessa: "Job",
      ricercaCommessaPh: "e.g. EG-21-055",
      ricercaBtn: "Search",
      ricercaTot: "Total hours",
      ricercaRighe: "Days/rows",
      ricercaPeriodo: "Period",
      ricercaPerCommessa: "Hours by job",
      ricercaPerOperaio: "Hours by worker",
      ricercaNoRes: "No results in the historical archive for this search.",
      ricercaPdfBtn: "Print PDF",
      ricercaFonte: "Source: old management-system archive (daily detail until 31/05/2026). Hours from 01/06/2026 live in the app reports.",
      commessaOpt: "Job (optional)",
      removeFilter: "Remove job filter",
      onlyVidim: "Approved reports only",
      selEmp: "Select employees", of: "of",
      searchEmp: "Search employee…", all: "All", none: "None",
      noEmpFound: "No employee found",
      onlyAdmins: "Statistics are available to admins and viewers only.",
      rapportini: "Reports", giorni: "Days", dipendenti: "Employees",
      oreTotali: "Total hours", caldo: "Hot work", notturne: "Night",
      costoManodopera: "Labour cost",
      esclusi: "materials and other costs excluded",
      totPerDip: "Totals by employee", totPerDip2: "Total by employee",
      dettaglio: "Occurrence detail",
      data: "Date", note: "Notes", totale: "Total",
      totCommessa: "Job total",
      selectedSummary: "Hours summary — {{count}} selected",
      periodo: "Period", inizio: "start", oggi: "today",
      filtroCommessa: "Filtered by job:",
      commesse: "Jobs",
    },
    list: {
      kicker: "Dashboard", title: "Work reports",
      exportCsv: "Export CSV", nuovo: "New",
      perSettimana: "By week", intervallo: "Custom range",
      tuttiRapp: "All reports", ordina: "Sort by…",
      sort: {
        dataDesc: "Date ↓ (newest)", dataAsc: "Date ↑ (oldest)",
        numDesc: "Report no. ↓", numAsc: "Report no. ↑",
        cmAsc: "Job ↑ (code)", cmDesc: "Job ↓",
        clAsc: "Client A→Z", clDesc: "Client Z→A",
      },
      reset: "Reset filters", cerca: "Search",
      searchPh: "Job, employee, notes…",
      dataPrecisa: "Exact date",
      dipendente: "Employee", tuttiDip: "All employees",
      tutte: "All", tutti: "All",
      soloMiei: "Only my reports",
      soloMieiSub: "(only shows reports I created)",
      settimana: "Week", da: "From", a: "To",
      statRapp: "Reports", statOre: "Total hours",
      statCommesse: "Jobs involved", statDip: "Employees involved",
      daVidimare: "to approve",
      vidimate: "approved", daApprovare: "pending",
      emptyTitle: "No work report found",
      emptySub: "Try widening the date range or resetting the filters.",
      nuovoRapp: "New work report",
      giorni: "days", vidimato: "Approved", daVidimareBadge: "To approve",
      nessunaCommessa: "No job",
      oreTotLower: "total hours", byCreator: "by",
      vidima: "Approve", modifica: "Edit", apri: "Open",
      vidimaTutti: "Approve all",
      annullaSel: "Clear selection", vidimaSel: "Approve selected",
      selCount: "{{count}} selected",
      unvidTitle: "{{count}} reports not approved",
      unvidSub: "They are shown with a \"To approve\" badge but are NOT included in the official totals (employee hours, summaries, timesheets). Approve them to make them official.",
      bozzeTitle: "{{count}} pending drafts",
      tuaBozza: "Your draft", bozzaDi: "Draft by",
      riprendi: "Resume", elimina: "Delete",
    },
    tour: {
      profileTitle: "App tutorial",
      profileSub: "Rewatch the guide anytime: full or quick, your choice.",
      profileBtn: "Rewatch tutorial",
      welcomeTitle: "Welcome to IL-Report{{name}}! 👋",
      welcomeSub: "The app to manage your crew's hours: work reports, jobs, approvals and timesheets. How would you like to start?",
      fullBtn: "Full tutorial",
      fullBtnSub: "Every feature explained step by step, from entering work reports to the final result (≈3 minutes)",
      shortBtn: "Quick tutorial",
      shortBtnSub: "Just the essentials, in 1 minute",
      skip: "Skip for now",
      dontShow: "Don't show this again at next login",
      back: "Back", next: "Next", start: "Start using the app",
      rewatchHint: "You can rewatch it anytime from your Profile.",
      fullBase: [
        { t: "Your Home", x: "From Home you reach everything with one tap: New work report, Week, Reports, Summary. At the top you see this week's hours and reports." },
        { t: "New report: date and days", x: "Tap \"New work report\": the app suggests today's date and the next number. You can add several days in the same report, one below the other." },
        { t: "Rows: job and crew", x: "In each row pick the job (just type the code) and the employee. Names autocomplete as you type, and a new row appears automatically." },
        { t: "Hours: drive, passenger, work", x: "Enter hours split by type: Drive, Passenger and Work (plus Hot work and Night for the workshop). Row and day totals are calculated for you." },
        { t: "Notes and job rules", x: "Some jobs require mandatory notes (at least 10 characters): the app reminds you on save. If a job is closed, no hours can be entered from the closing date onward." },
        { t: "Save, drafts and offline", x: "Save when you're done. Missing something? Save as a draft and resume it from the Reports list. Works offline too: data syncs as soon as you're back online." },
        { t: "Jobs on the fly", x: "New job code? Create it on the fly with description and client, without leaving the report. The -OFF workshop twin is created automatically." },
        { t: "Week and Reports list", x: "In \"Week\" you see filled and missing days at a glance. In \"Reports\" you filter by job, employee or period and search in notes." },
      ],
      fullAdmin: [
        { t: "Approve: make hours official", x: "In \"To approve\" you approve your crew's reports: only approved hours count in the official totals. In \"To fix\" you find incomplete records and pending confirmations." },
        { t: "Summary and ERP export", x: "In \"Summary\" you see hours aggregated by job and download the Excel for your ERP. The card in Home reminds you up to which date the last export covers." },
        { t: "Employee timesheets", x: "In \"Timesheets\" you generate the monthly PDF of each employee's hours: ready for payroll or archive." },
        { t: "Statistics and hour budgets", x: "In \"Statistics\" you analyse hours and labour cost by job or employee. Set an hours budget on jobs: we alert you at 80%." },
        { t: "Jobs and users", x: "From the \"Jobs\" list you manage budgets, mandatory notes and job closing. From \"Users\" you invite your team and set roles and permissions." },
      ],
      fullUser: [
        { t: "Send and let us handle it", x: "When you save a report, the administrator receives and approves it. You can edit it until it has been approved." },
      ],
      shortBase: [
        { t: "Fill in the work report", x: "From \"New work report\" enter date, job, crew and hours. Rows are added as you type. Works offline too." },
        { t: "Your week at a glance", x: "In the \"Week\" view you instantly see filled and missing days. One tap on \"Fill in\" and you're inside that day's report." },
        { t: "Jobs on the fly", x: "Type a new job code right in the report: if it doesn't exist, we offer to create it on the fly. Zero interruptions." },
      ],
      shortAdmin: [
        { t: "Approve and keep things tidy", x: "In \"To approve\" you approve your crew's reports. In \"To fix\" you find incomplete records and pending confirmations." },
        { t: "Timesheets, statistics and budgets", x: "Monthly PDF timesheets per employee, statistics by job, Excel export for your ERP and hour budgets with an 80% alert." },
      ],
      shortUser: [
        { t: "Send and let us handle it", x: "When you save a report, the administrator receives and approves it. You can edit it until it has been approved." },
      ],
      end: { t: "The final result 🚀", x: "From paper to digital: tidy reports, approved hours, PDFs and Excel ready for your ERP. You can rewatch this tutorial anytime from your Profile. Enjoy!" },
    },
    set: {
      autoSend: "Auto-send on save",
      autoSendSub: "When on, every new saved report is automatically emailed to the recipients below.",
      subject: "Email subject (template)",
      subjectVars: "Available variables:",
      recipients: "Recipients (To)",
      add: "Add",
      noRecipients: "No recipients configured",
      provider: "Email provider configuration",
      formatoTitle: "🏷 Job code format",
      exportTitle: "ERP export — default hourly cost",
      exportSub: "Value in €/h used in the \"Cost\" column of the Excel downloadable from the Summary page.",
      overtimeTitle: "Excessive hours warning threshold",
      overtimeSub: "The app shows a warning when an employee exceeds this number of hours in a single day. Default: 13 hours.",
      orePerGiorno: "hours / day",
      recentTitle: "Recent jobs on Home",
      recentSub: "How many \"latest jobs created\" to show in the Home strip. Default: 10.",
      commesseUnit: "jobs",
      capTitle: "8 hours MAX",
      capSub: "When on, all users — admins included — see at most 8 hours per employee per day everywhere in the app (lists, summaries, PDFs, Excel, emails) and enter whole hours only. Non-destructive toggle: database data is never modified.",
      notifyTitle: "✉ Notify admins about unapproved reports",
      backupTitle: "🛡 Automatic hours backup via email",
      backupSub: "Receive at {{email}} an Excel with ALL hours: full detail, totals per job and monthly hours employee by employee.",
      backupFreq: "Frequency",
      backupWeekly: "Every week",
      backupMonthly: "Every month",
      backupLast: "Last backup sent",
      backupNever: "never",
      backupNow: "Send backup now",
      backupSending: "Sending…",
      backupSentOk: "Backup sent! Check your email",
      backupEmpty: "No recorded hours to save",
      backupErr: "Backup send failed",
      notifySub: "When on, whenever a foreman saves a report the administrators with \"Receives reports by email\" enabled get a notice with only a link to \"To approve\" (no PDF attached).",
      upperTitle: "Display everything in UPPERCASE",
      upperSub: "When on, all texts are shown in UPPERCASE in the interface. Saved data remains unchanged.",
      maintTitle: "App maintenance (PWA cache)",
      maintSub: "If you see stale data or outdated settings, use this button to fully clear the local cache and reload. Safe operation: no report is deleted.",
      tipsTitle: "✨ Daily Boost quotes",
      tipsSub: "{{active}} active quotes out of {{total}}: they rotate one per day on the Home of users who have the quote enabled. Edit, disable or add your own.",
      tipsAdd: "Add quote",
      tipsShow: "Show all {{total}} quotes",
      tipsHide: "Hide quotes",
      tipsEdit: "Edit quote",
      tipsReset: "Restore defaults",
      tipsResetConfirm: "Restore the 65 default quotes? Edits and custom quotes will be deleted.",
      tipsResetDone: "Default quotes restored",
      tipsDeleteConfirm: "Delete this quote?",
      tipsSearch: "Search quotes…",
      tipsNone: "No quotes found",
      tipsCustom: "custom",
      tipsTextIt: "Text (Italian)",
      tipsTextEn: "Text (English) — optional",
      tipsTextEnHint: "If empty, English users will see the Italian text.",
      tipsRequired: "The quote text is required",
      tipsErr: "Operation failed",
      tipsCancel: "Cancel",
      tipsSave: "Save",
      companyNameLabel: "Company name shown on Home",
      companyNamePh: "e.g. Europe Glass",
      prefixRenameConfirm: "You are changing the job-code prefix from {{old}} to {{new}}.\n\nALL existing jobs and reports will be renamed automatically (e.g. {{old}}-01-001 → {{new}}-01-001).\n\nContinue?",
      prefixRenamed: "Prefix updated: {{commesse}} jobs and {{rapportini}} reports renamed from {{old}} to {{new}}",
      maintBtn: "Clear cache and reload",
      saveBtn: "Save settings",
      lastExportFooter: "Last ERP export:",
      saved: "Settings saved",
      saveErr: "Save failed",
    },
    setup: {
      title: "🚀 Let's get started! Set up your company",
      titleDone: "Setup complete!",
      sub: "{{done}} of {{total}} steps done — follow the guide and you'll be up and running in minutes.",
      subDone: "Your company is ready: it's all downhill from here.",
      stepAzienda: "Register your company (the name is enough, the rest can come later)",
      stepAdmin: "Create the administrator profile",
      stepDipendente: "Add your first employee",
      stepCommessa: "Create your first job",
      stepRapportino: "Enter your first report with hours",
      ctaDipendente: "Add",
      ctaCommessa: "Create",
      ctaRapportino: "Enter",
      finishBtn: "Great, close the guide",
    },
    intro: {
      badge: "Intro · 60 seconds",
      skip: "Skip",
      tapHint: "Tap to continue",
      startBtn: "Let's start",
      welcomeTitle: "Welcome to IL-Report",
      welcomeSub: "Your crew's hours under control: reports, jobs and statistics in a single app.",
      rapportiniTitle: "Reports in seconds",
      rapportiniSub: "Job, crew and hours: your team fills in from the phone, even offline on site.",
      rowOperaio: "Worker",
      vidimaTitle: "Approval and control",
      vidimaSub: "The admin approves reports with one tap: everything tracked, no more lost paper sheets.",
      vidimaBadge: "Report",
      statsTitle: "Statistics, prints and exports",
      statsSub: "Hours per job and employee, ready-to-send PDFs and the ERP export.",
      boostTitle: "A motivated, safe crew",
      boostSub: "Every day a quote about output, leadership and site safety — customizable by the admin.",
      boostQuote: "Safety isn't a cost: it's the signature of a leader who brings the whole team home, every evening.",
      goTitle: "Ready? Let's go!",
      goSub: "Register your company, add your first employee and create your first report: the guide walks you through it.",
      profileTitle: "App intro (60 seconds)",
      profileSub: "Rewatch the animated intro shown at first access.",
      profileBtn: "Rewatch intro",
    },
  },
};

const saved = typeof window !== "undefined" ? localStorage.getItem("il_report_lang") : null;

i18n.use(initReactI18next).init({
  resources: { it, en },
  lng: saved || "it",
  fallbackLng: "it",
  defaultNS: "common",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

i18n.on("languageChanged", (lng) => {
  try { localStorage.setItem("il_report_lang", lng); } catch (e) {}
});

export default i18n;
